// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nO-V","newExpiryDate":"styles_newExpiryDate__3t_bR","footer":"styles_footer__3vLzx"};